<script>
import { getBuyerAds } from '@/graphql/buyer/getBuyerAds.graphql';

import { QueryHelper } from '@/components/Core/Helpers';

import { AdStatus } from '@/constants';

export default {
  mixins: [QueryHelper],
  props: {
    pager: {
      type: Object,
      required: true
    }
  },

  query(props) {
    let filter = props.pager.filter;

    if (!filter.status || !filter.status.length) {
      filter.status = [AdStatus.VERIFIED];
    }

    return {
      query: getBuyerAds,
      variables: {
        buyer_id: this.$store.getters['auth/buyerId'],
        ...props.pager,
        filter
      }
    };
  }
};
</script>
